<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import { sessionHelper, ddlHelper } from "@/utils";
import { SESSION, SHARED, MODULE } from "@/constants";
import { mapState } from "vuex";
import { PURPOSE_MODULE } from '@/state/modules/purpose'
import { purposeMethods } from "@/state/helpers";

export default {
    page: {
        title: i18n.t("label.listingX", [i18n.t('module.purpose')]),
    },
    beforeRouteLeave(to, from, next) {
        if (to.name != 'Purpose-update' && to.name != 'Purpose-create') {
            sessionHelper.clearSearch(SESSION.PURPOSE_SEARCH)
        }
        next();
    },
    async created() {
        await this.validPermissions();
        this.initSearchCriteria();
    },
    components: { Layout, PageHeader },
    data() {
        return {
            module: MODULE.PURPOSE,
            title: i18n.t("label.listingX", [i18n.t('module.purpose')]),
            items: [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.purpose"),
                    active: true,
                },
            ],
            statusDdl: ddlHelper.getActivationStatus(true),
            accountLockStatusDdl: ddlHelper.getAccountLockStatus(true),
            currentUser: sessionHelper.getUserEmail(),
            currentPage: 1,
            filter: "",
            enabled: false,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            pageOptions: [10, 25, 50, 100],
            filterOn: [],
            permissions: sessionHelper.getPermissions(),
            createPermission: null,
            updatePermission: null,
            updateStatusPermission: null,
            readPermission: null,
            sortBy: "name",
            fields: [
                { key: "name", sortable: true, label: i18n.t("label.name"), },
                { key: "isActive", sortable: true, label: i18n.t("label.status") },
                { key: "Action", sortable: false, label: i18n.t("label.action"), },
            ],
        };
    },
    computed: {
        ...mapState(PURPOSE_MODULE, ['status']),
        tableRows() {
            return this.$store.state.purpose.list.data;
        },
        pagination() {
            return this.$store.state.purpose.list.pagination;
        },
        totalPage() {
            return this.$store.state.purpose.list.pagination.total;
        },
    },
    mounted() { },
    methods: {
        ...purposeMethods,
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_PURPOSE_PC")) {
                this.createPermission = true;
            }
            else {
                this.createPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PURPOSE_PR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PURPOSE_PU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PURPOSE_PUS")) {
                this.updateStatusPermission = true;
            }
            else {
                this.updateStatusPermission = false;
            }
        },
        initSearchCriteria() {
            let isDefault = true;

            if (sessionHelper.hasSearchCriteria(SESSION.PURPOSE_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PURPOSE_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }

            if (isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: this.statusDdl[0].value,
                    isLocked: this.accountLockStatusDdl[0].value,
                    searchValue: "",
                    searchArray: [],
                };
            }
            if (this.readPermission == true) {
                this.getPurposeList(this.searchCriteria);
            }
        },

        getPurposeList(filter) {
            this.getAllPurposes({ filter });
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.PURPOSE_SEARCH, filter);
        },

        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.PURPOSE_SEARCH);
            filter.pageNumber = pageNumber;

            this.getPurposeList(filter);
        },

        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;

            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getPurposeList(this.searchCriteria);
        },

        editStatus(printerProof) {
            const data = {
                id: printerProof.uuid,
                isActive: printerProof.isActive,
            };

            this.updatePurposeStatus({ filter: this.searchCriteria, data });
        },

        toDetailsPage(id) {
            let filter = sessionHelper.retrieveSearch(SESSION.PURPOSE_SEARCH)
            filter.selectedRecordId = id
            sessionHelper.storeSearch(SESSION.PURPOSE_SEARCH, filter)

            this.$router.push({
                name: 'Purpose-update', // Name of the route
                query: {
                    module: MODULE.PURPOSE,
                }
            });
        },

    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right"
                                    style="float: left">
                                    <label class="d-inline-flex align-items-center">
                                        {{ $t("label.search") }}
                                        <b-form-input v-model="filter" type="search" :placeholder="$t('label.search')"
                                            class="form-control form-control-sm ml-2"
                                            @change="searchListing"></b-form-input>
                                    </label>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right"
                                    style="float: right">
                                    <router-link tag="a" :to="'/purpose/create?module=' + module"
                                        v-if="createPermission == true" style="float: right; margin-bottom: 10px"
                                        class="btn btn-primary w-md waves-effect waves-light">
                                        {{ $t('label.createX', [$t('module.purpose')]) }}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage"
                                v-if="readPermission == true">
                                <template #cell(isActive)="data">
                                    <b-form-checkbox @change="editStatus(tableRows[data.index])"
                                        v-model="tableRows[data.index].isActive" switch class="mb-1"
                                        :disabled="updateStatusPermission == false">
                                    </b-form-checkbox>
                                </template>

                                <template #cell(isLocked)="data">
                                    <span v-if="tableRows[data.index].isLocked == true">{{ $t('label.lock') }}</span>
                                    <span v-else>{{ $t('label.active') }}</span>
                                </template>

                                <template #cell(action)="data">
                                    <a href="javascript:void(0);" :class="currentUser == tableRows[data.index].email
                                        ? 'disabled text-warning'
                                        : 'text-primary'
                                        " @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover
                                        v-if="readPermission == true && updatePermission == true" title="Edit">
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>

                                    <a href="javascript:void(0);" :class="currentUser == tableRows[data.index].email
                                        ? 'disabled text-warning'
                                        : 'text-primary'
                                        " @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover
                                        style="margin-left: 5px;"
                                        v-if="readPermission == true && updatePermission != true" title="Read">
                                        <i class="mdi mdi-file-search-outline font-size-18"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div style="text-align: center;" v-else>
                                {{ $t('message.noPermissionMessage') }}
                            </div>
                        </div>
                        <div class="row" v-if="readPermission == true">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="totalPage" :per-page="perPage"
                                            @change="pageNavigation"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
a.disabled {
    pointer-events: none;
    cursor: default;
}
</style>